import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (window.location.hostname === 'localhost' ? 'http://localhost:8000' : '/api');

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  signup: (userData) => api.post('/auth/signup', userData),
  login: (credentials) => api.post('/auth/login', credentials),
  getCurrentUser: () => api.get('/auth/me'),
};

// Chat API
export const chatAPI = {
  sendMessage: (message, conversationId = null) =>
    api.post('/chat/message', { message, conversation_id: conversationId }),
  getConversations: () => api.get('/chat/conversations'),
};

// Sites API
export const sitesAPI = {
  analyzeSites: (domains, context = null) =>
    api.post('/sites/analyze', { domains, context }),
  getSiteAnalysis: (domain) => api.get(`/sites/analysis/${domain}`),
  confirmSiteData: (confirmationData) =>
    api.post('/sites/confirm', confirmationData),
  listSites: () => api.get('/sites/list'),
};

// Export API
export const exportAPI = {
  exportCSV: (params) => api.get('/export/csv', { params, responseType: 'blob' }),
  getSitesList: (params) => api.get('/export/sites-list', { params }),
  getUsage: () => api.get('/export/usage'),
};

export default api;
